export const areaList = state => {
  let temp = state.areaList
  let data = []

  temp.forEach(item => {
    let childs = item.childs
    let obj = {}
    obj.id = item.id
    obj.label = item.name
    obj.level = item.area_level_id
    obj.children = []

    if (childs.length) {
      childs.forEach(child => {
        obj.children.push({
          id: child.id,
          label: child.name,
          level: child.area_level_id
        })
      })
    }

    data.push(obj)
  })

  return data
}

export const areaDsmList = state => {
  let temp = state.dsmList
  let data = []

  if (Array.isArray(temp) && temp.length)
    temp.forEach(item => {
      data.push({
        value: item.id,
        text: item.name
      })
    })

  return data
}
